(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/game-promotion-pix/assets/javascripts/fetch-draws.js') >= 0) return;  svs.modules.push('/components/banner_layouts/game-promotion-pix/assets/javascripts/fetch-draws.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const isServer = typeof exports === 'object';
const trinidad = isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
let logger;
let getDrawName;
let createApiProxy;
const {
  getFormattedDate,
  getFormattedTime
} = isServer ? trinidad.components.require('lb-utils', 'helper-formatdate').api : svs.components.lbUtils.helpers.formatDate;
const {
  productIds
} = isServer ? trinidad.components.require('utils', 'products') : svs.utils.products;
const normalizeDraw = draw => {
  const events = draw.drawEvents || draw.events || [];
  return _objectSpread(_objectSpread({}, draw), {}, {
    drawEvents: events.slice(0, 3),
    drawCloseTimeFormatted: "Spelstopp ".concat(getFormattedDate(draw.regCloseTime, true, false, true), " ").concat(getFormattedTime(draw.regCloseTime))
  });
};
const normalizeDraws = drawsData => drawsData.map(draw => normalizeDraw(draw));
if (!isServer) {
  createApiProxy = () => svs.components.lbUtils.apiProxy.ApiProxy.create();
  getDrawName = svs.utils.products.getDrawName;
  logger = new svs.core.log.Logger('banner_layout:game-promotion-draw');
} else {
  createApiProxy = () => trinidad.components.require('lb-utils', 'api-proxy').api.create();
  getDrawName = trinidad.components.require('utils', 'products').getDrawName;
  logger = trinidad.logger('banner_layout:game-promotion-draw');
}
const removeBySportId = (draws, sportId) => draws.filter(draw => draw.sport.type === sportId);

const fetchDrawsByProductId = async (productId, req) => {
  if (!productId) {
    throw new Error('Product ID is required to fetch a single draw.');
  }
  const productName = getDrawName(productId);
  const apiProxy = createApiProxy();
  try {
    const data = await apiProxy.fetch("/draw/1/".concat(productName, "/draws"), {
      method: 'GET',
      req: isServer ? req : undefined
    });
    return normalizeDraws(data.draws);
  } catch (error) {
    logger.error("Error fetching draws for product ".concat(productId, ":"), error);
    return [];
  }
};
const fetchSingleDrawByProductId = async (productId, drawNumber, req) => {
  if (!drawNumber) {
    throw new Error('Draw number is required to fetch a single draw.');
  }
  if (!productId) {
    throw new Error('Product ID is required to fetch a single draw.');
  }
  const productName = getDrawName(productId);
  const apiProxy = createApiProxy();

  if (productId === productIds.T8) {
    const data = await fetchDrawsByProductId(productId, req);
    return data.find(draw => draw.drawNumber === Number(drawNumber)) || null;
  }
  try {
    const data = await apiProxy.fetch("/draw/1/".concat(productName, "/draws/").concat(drawNumber), {
      method: 'GET',
      req: isServer ? req : undefined
    });
    return normalizeDraw(data.draw);
  } catch (error) {
    logger.error("Error fetching single draw for product ".concat(productId, " and draw number ").concat(drawNumber, ":"), error);
    return null;
  }
};

const fetchDrawsBySportId = async (productId, sportId, req) => {
  if (!sportId) {
    throw new Error('Sport ID is required to fetch draws by sport.');
  }
  try {
    const draws = await fetchDrawsByProductId(productId, req);
    return removeBySportId(draws, sportId);
  } catch (error) {
    logger.error("Error fetching draws for product ".concat(productId, " and sport ").concat(sportId, ":"), error);
    return [];
  }
};

const fetchDrawByDrawNumber = async (productId, drawNumber, req) => {
  if (!drawNumber) {
    throw new Error('Draw number is required to fetch draws by draw number.');
  }
  try {
    const draws = await fetchSingleDrawByProductId(productId, drawNumber, req);
    return [draws];
  } catch (error) {
    logger.error("Error fetching draws for product ".concat(productId, " and draw number ").concat(drawNumber, ":"), error);
    return [];
  }
};

const fetchDrawBySportId = async (productId, drawNumber, sportId, req) => {
  if (!sportId) {
    throw new Error('Sport ID is required to fetch draw by sport ID.');
  }
  try {
    const draws = await fetchSingleDrawByProductId(productId, drawNumber, req);
    return [draws].filter(draw => draw.sport.type === sportId);
  } catch (error) {
    logger.error("Error fetching draws for product ".concat(productId, " and sport ID ").concat(sportId, ":"), error);
    return [];
  }
};
if (isServer) {
  module.exports = {
    fetchDrawsByProductId,
    fetchDrawsBySportId,
    fetchDrawByDrawNumber,
    fetchDrawBySportId
  };
} else {
  setGlobal('svs.banner_layouts.game_promotion_pix', {
    fetchDrawsByProductId,
    fetchDrawsBySportId,
    fetchDrawByDrawNumber,
    fetchDrawBySportId
  });
}

 })(window);